<template>
  <PageAssessmentRun
    v-if="pageContextType === CategoryPageContextTypes.AssessmentRun"
  />
  <PageAdventure v-else-if="category.contentType === 'adventure'" />
  <PageLib v-else />
</template>
<script lang="ts" setup>
const {
  categoryManager: { category },
  pageContextType,
} = inject(INJECT_CATEGORY_PAGE);
</script>
